import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DirectSearchService } from 'src/_services';

const MOBILEVIEWWIDTH = 575;

@Component({
  selector: 'app-side-panel-direct-search',
  templateUrl: './side-panel-direct-search.component.html',
  styleUrl: './side-panel-direct-search.component.css'
})
export class SidePanelDirectSearchComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];
  isDSResultsShown: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private directSearch: DirectSearchService,
  ) { }

  ngOnInit(): void {
    this.subscribeDirectSearchResultsIsShown();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngAfterContentChecked() {
    if(this.isDSResultsShown) {
      this.setFormContainerHeight();
    }
  }
  
  subscribeDirectSearchResultsIsShown() {
    const directSearchResultsIsShown = this.directSearch.onIsResultsShown.subscribe({
      next: data => {
        this.isDSResultsShown = data;
      },
      error: err => {
        this.isDSResultsShown = false;
      }
    });
    this.subscriptions.push(directSearchResultsIsShown);
  }

  setFormContainerHeight() {
    const formContEl = this.document.getElementsByClassName('side-panel-direct-search-container')[0];
    const panelsContainer = this.document.getElementById('comparatoreMFPanels');

    if(panelsContainer != null && formContEl != null) {
      if(panelsContainer.offsetWidth > MOBILEVIEWWIDTH) {
        const sidePanelEl = this.document.getElementsByClassName('side-panel-container')[0];
        const spTitleEl = this.document.getElementsByClassName('side-panel-title-container')[0];
        const spProductsEl = this.document.getElementsByClassName('side-panel-products-container')[0];
        const padding = 24;

        if(sidePanelEl != null && spTitleEl != null && spProductsEl != null) {
          const hSidePanel = (sidePanelEl as HTMLElement).offsetHeight;
          const hSpTitle = (spTitleEl as HTMLElement).offsetHeight;
          const hSpProducts = (spProductsEl as HTMLElement).offsetHeight;
          

          const totHeight = hSpTitle + hSpProducts + padding;
          const hTagsCont = hSidePanel - totHeight - 5;

          (formContEl as HTMLElement).style.height = `${hTagsCont}px`;
        }
      }
    }
  }

}
